import React from "react";
import qs from "qs";
import config from "../../config";
import { RaisedButton } from "material-ui";

const LOGIN_BASE_URL = config.login_url;

class AarpLogin extends React.Component {
  constructor(props) {
    super(props);
    this._receiveMessage = this._receiveMessage.bind(this);
    this.callback = this.callback.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  componentWillMount() {
    window.addEventListener("message", this._receiveMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this._receiveMessage);
    clearInterval(this.interval);
  }

  _receiveMessage(e) {
    if (e.origin !== LOGIN_BASE_URL) {
      return;
    }

    this.callback(e.data);
  }

  componentDidMount() {
    let loc = this.context.router.getCurrentLocation();
    if (loc && loc.query && loc.query.aarp_auth) {
      setTimeout(() => this.callback(loc.query), 0);
    }
  }

  onLogin() {
    window.location.href = `${config.endpoint}auth/aarp?${qs.stringify({
      api_key: config.api_key,
      redirect:
        window.location.href +
        (window.location.href.indexOf("?") === -1 ? "?" : "&") +
        "aarp_auth=true"
    })}`;
  }

  callback(data) {
    const { success, failure } = this.props;

    if (!data.token) {
      failure(
        new Error(
          `Unable to login to AARP: ${
            data.error_description || data.error || "Unknown error"
          }`
        )
      );
    } else {
      success(data.token);
    }
  }

  render() {
    const label = this.props.label || "AARP Login";

    return (
      <div>
        <RaisedButton
          primary
          onClick={this.onLogin}
          labelStyle={{ textTransform: "none" }}
          label={label}
        />
      </div>
    );
  }
}

AarpLogin.contextTypes = {
  router: React.PropTypes.object
};

export default AarpLogin;



// WEBPACK FOOTER //
// ./src/app/components/partials/aarp-login.jsx